





















import {
  Component,
  Emit,
  Prop,
  PropSync,
  Ref,
  Vue
} from "vue-property-decorator";
import { uploadOSS } from "@root/utils/file/upload";
import GtImportDialog from "@root/components/gt-import-dialog/index.vue";
import { loading } from "@root/lib/decorator";

@Component({
  components: {
    GtImportDialog
  }
})
@loading()
export default class CustomImportButton extends Vue {
  @Prop({ type: Object, default: () => ({}) }) options: any;
  @Prop({ type: Function, default: () => {} }) beforeOpen: Function; // 打开弹窗之前触发
  @Prop({ type: Function, default: () => {} }) importMethod: Function;
  @Prop({ type: Function }) beforeUpload: Function;
  @Prop({ type: Boolean, default: true }) oss: boolean; // 是否需要上传oss
  @Prop({ type: Boolean, default: false }) disabled: boolean;

  @Ref("importDialog") importDialogRef: any;

  // show dialog
  private visible: Boolean = false;

  async openDialog() {
    this.beforeOpen && (await this.beforeOpen());
    this.visible = true;
    await this.$nextTick();
    // 每次打开弹窗，清空文件。
    this.importDialogRef.clearFiles();
  }

  // 上传前验证
  beforeUploadMethod(fileList = []) {
    if (!fileList.length) {
      this.$message.error(this.$t("Root.Upload.select_tip") as string);
      return false;
    }
    return true;
  }

  async importFile(fileList) {
    const [res = {}] = fileList;
    let data: any,
      filePath = "";
    // oss upload
    if (this.oss) {
      data = await uploadOSS({ file: res.file });
      filePath = data.filePath;
    }
    // upload
    await this.importMethod({
      file: res.file,
      filePath
    });
    this.visible = false;
  }
}
